import { render, staticRenderFns } from "./area-manage.vue?vue&type=template&id=37e17042"
import script from "./area-manage.vue?vue&type=script&lang=js"
export * from "./area-manage.vue?vue&type=script&lang=js"
import style0 from "./area-manage.vue?vue&type=style&index=0&id=37e17042&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e17042')) {
      api.createRecord('37e17042', component.options)
    } else {
      api.reload('37e17042', component.options)
    }
    module.hot.accept("./area-manage.vue?vue&type=template&id=37e17042", function () {
      api.rerender('37e17042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/area-manage.vue"
export default component.exports